const homePageBlogsArray = [
    // { 
    //     DSOrA:'Algorithm',
    //     Link: '#',
    //     Header: 'Integer Reversal',
    //     Description: 'Take an integer and reverse it. ',

    // },
    // {
    //     DSOrA:'Algorithm',
    //     Link: '#',
    //     Header: 'Palindrome',
    //     Description: 'Take the string, reverse it, and compare it to the original input.',

    // },
    {
        DSOrA:'Algorithm',
        Link: '/reverse-string',
        Header: 'Reverse a String',
        Description: 'Take the string and reverse it using a decrementing for loop.',

    }
]

export default homePageBlogsArray;